define('js/ph',['require','jquery','../../common/js/isPhone','../../cloud-pro/js/showIframe','../../cloud-mobile/js/store','../../cloud-pro/js/xray','utm'],function(require) {
    var $ = require('jquery');
    var isPhone = require('../../common/js/isPhone');
    var showIframe = require('../../cloud-pro/js/showIframe');
    var store = require('../../cloud-mobile/js/store');
    var proXray = require('../../cloud-pro/js/xray');
    var utm = require('utm');
    var isProPage = window.location.pathname.indexOf('/promo/pro') === 0;

    if (document.referrer) {
        $('a.js-signup').prop('href', function (i, oldVal) {
            try {
                return oldVal + (oldVal.indexOf('?') < 0 ? '?' : '&') + 'promo_referrer=' + (new URL(document.referrer).hostname);
            } catch (_) {
                return oldVal;
            }
        });
    }

    if (!window.__PH) {
        return;
    }

    function onClick(event) {
        var currentUrl;
        var targetUrl;
        var href = event.currentTarget.href;
        var tariffId = '';
        var tempUrl;
        var clientId;
        var proAb;

        if (isPhone && typeof window.__AG !== 'undefined') {
            try {
                window.__AG.setSettings({
                    mobile_redirect: true
                });
            } catch (error) {
                console.error(error);
            }
        }

        if (href.indexOf('page=') !== -1) {
            try {
                href = href
                    .split('?')[1]
                    .split('&')
                    .filter(function(part) {
                        return part.indexOf('page=') === 0;
                    })[0]
                    .split('=')[1];

                href = decodeURIComponent(decodeURIComponent(href));

                if (isProPage) {
                    clientId = store.get('clientId');
                    tempUrl = new URL(href);
                    tariffId = tempUrl.searchParams.get('productId');
                    tempUrl.searchParams.set('clientId', clientId);
                    tempUrl.searchParams.set('from', 'landingPro');

                    href = tempUrl.toString();

                    proXray.sendProXray('click-tariff', tariffId);
                }
            } catch (error) {
                console.error(error);
            }
        }

        href = href.replace(/(\W)cloud\.mail\.ru/, '$1' + window.location.host);

        if (window.URL && window.location.search) {
            currentUrl = new window.URL(window.location.href);
            targetUrl = new window.URL(href);
            utm.UTM_TYPES.forEach(function(utmType) {
                if (currentUrl.searchParams.has(utmType)) {
                    targetUrl.searchParams.set(utmType, currentUrl.searchParams.get(utmType));
                }
            });
            href = targetUrl.toString();
        }

        if (window.__PH.activeUser()) {
            if (isProPage) {
                showIframe(tariffId);
                return;
            }

            window.location.assign(href);
            return;
        }

        // if no action param in target link - than return to current page after login
        // ex. cloud.mail.ru/search/?query=213&searchType=all
        if (window.location.pathname !== '/' && href.indexOf('action=') === -1) {
            href = window.location.href;
        }

        if (isProPage) {
            var newUrl = new URL(window.location.href);
            newUrl.searchParams.set('from-auth', '1');
            newUrl.searchParams.set('tariff-id', tariffId);
            newUrl.hash = 'tariffs';
            href = newUrl.toString();
        }

        window.__PH.authForm.show({
            successPage: href,
            lang: 'ru_RU'
        });
    }

    $(document).delegate('.js-signin', 'click', function(event) {
        event.preventDefault();

        onClick(event);
    });
});

